<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-card>
      <div class="flex items-start mb-5px">
        <h4 class="mt-12px">审核状态</h4>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item.label"
            :name="item.value"
            v-for="item in statusTag"
            :key="item.value"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="mt-8px">
        <com-finance-list
          :defaultParams="defaultParams"
          @audit="handleAudit"
          @detail="handleDetail"
          ref="table"
        ></com-finance-list>
      </div>
    </com-card>
    <the-check-dialog ref="checked" @success="update"></the-check-dialog>
  </com-page>
</template>

<script>
// import utils from 'my-tools-library'

import theCheckDialog from './components/the-check-dialog'

export default {
  components: { theCheckDialog },
  data() {
    return {
      activeName: '0',
      defaultParams: {
        status: null
      },
      statusTag: [
        {
          label: '全部',
          value: '0'
        },
        {
          label: '待审核',
          value: '1'
        },
        {
          label: '通过',
          value: '2'
        },
        {
          label: '拒绝',
          value: '3'
        }
      ],
      searchColumns: [
        {
          label: '合伙人名称',
          prop: 'partnerName',
          type: 'input'
        },
        {
          label: '提现方式',
          prop: 'type',
          type: 'select',
          option: [
            {
              label: '微信',
              value: 1
            },
            {
              label: '银行卡',
              value: 2
            }
          ]
        },
        {
          label: '提现时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      console.log('val :>> ', this.activeName)
      if (this.activeName === '0') {
        this.defaultParams.status = ''
      } else {
        this.defaultParams.status = +this.activeName
      }
      this.$refs.table.update()
    },
    handleAudit(row) {
      this.$refs.checked.open(row)
    },
    handleDetail(row) {
      this.$refs.checked.open(row)
    },
    handleSearch(val) {
      const params = {
        ...val,
        queryBeginTime: val.beginTime,
        queryEndTime: val.endTime
      }
      this.$refs.table.search(params)
    },
    update() {
      this.$refs.table.update()
    }
  }
}
</script>

<style lang="scss" scoped></style>
